import React from "react";

/** Render x-close icon */
const XCloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="24"
      height="24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="feather feather-x-circle"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M15 9L9 15"></path>
      <path d="M9 9L15 15"></path>
    </svg>
  );
};

export default XCloseIcon;
